export default __webpack_public_path__ + "static/media/assessment-calendar.ab0d1510.svg";